import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {PlanningPanelModel} from "../../../models/planning-panel.model";
import {PlanningViewSettingsResourcesModel} from "../../../models/planning-view-settings.model";
import {CdkDragDrop} from "@angular/cdk/drag-drop";
import * as _ from "lodash";
import {ResourceSegmentModel} from "../../../models/resource-segment.model";
import {PlanningRouteModel} from "../../../models/planning-route.model";
import {PlanningDragAndDropService} from "../../services/planning-drag-and-drop.service";

require('./planning-draft-resource-table-drilldown.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-resource-table-drilldown',
  templateUrl: './planning-draft-resource-table-drilldown.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftResourceTableDrilldownComponent implements OnInit, OnChanges {

  @Input() resource: ResourceSegmentModel;
  @Input() resources: ResourceSegmentModel[];
  @Input() routes: PlanningRouteModel[];
  @Input() visibleRouteIds: string[];
  @Input() settings: PlanningViewSettingsResourcesModel;
  @Input() routesSettings: any;
  @Input() draft: any;
  @Input() panels: PlanningPanelModel[];
  @Input() panel: PlanningPanelModel;
  @Input() itemElementSize?: string;
  @Input() selectedJobIds: string[];
  @Input() jobs: any[];

  @Output() onClose = new EventEmitter<void>();
  @Output() onDrilldown = new EventEmitter<{ routeId: string }>();
  @Output() onDrilldownFloating = new EventEmitter<{ routeId: string }>();
  @Output() onEditResourceAllocation = new EventEmitter<{ resource: any, route: any, event: any }>();
  @Output() onChangeRouteResource = new EventEmitter<{ routeId: string, event: any }>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onVisibleRoutesChange = new EventEmitter<string[]>();
  @Output() onDispatchRoutes = new EventEmitter<string[]>();
  @Output() onReoptimize = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onChangeResourceSequence = new EventEmitter<{ orderedRouteIds: string[], routeGroupId: string[] }>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onDispatch = new EventEmitter<string>();
  @Output() onCreateRoute = new EventEmitter<{ id: string, jobIds: string[], stopIdOrder?: string[], optimize?: boolean, allowSkillsMismatch?: boolean }>();
  @Output() onUpdateRouteResource = new EventEmitter<{ route: any, resourceId: string }>();
  @Output() onRoutesSettingsChange = new EventEmitter<any>();

  public sortedRoutes: PlanningRouteModel[];
  public hovered: boolean = false;
  public connectedPanelIds: string[];

  constructor(
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(PlanningDragAndDropService) private planningDragAndDropService: PlanningDragAndDropService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.panels) {
      const filteredPanels = _.filter(this.panels, (p) => {
        return p.id !== this.panel.id;
      });
      this.connectedPanelIds = _.map(filteredPanels, 'id');
    }

    if (changes.routes) {
      this._setSortedRoutes();
    }

    if (changes.resources && this.resources) {
      this.connectedPanelIds = (this.connectedPanelIds || []).concat(this.resources.map(resource => resource.id));
    }

    this.cdr.detectChanges();
  }

  drop(event: CdkDragDrop<any>) {
    this.planningDragAndDropService.onDropResourceRoutes(
      event,
      this.resource,
      this.selectedJobIds,
      (hovered: boolean) => this.hovered = hovered,
      this.jobs
    ).then((result) => {
      if (result) {
        if (result.type === 'sequence') {
          this.onChangeResourceSequence.emit(result.data);
        } else if (result.type === 'update') {
          this.onUpdateRouteResource.emit(result.data);
        } else if (result.type === 'create') {
          this.onCreateRoute.emit(result.data);
        }
      }
    });
  }

  private _setSortedRoutes(): void {
    if (!this.routes) {
      this.sortedRoutes = [];
      return;
    }
    this.sortedRoutes = [...this.routes].sort((a, b) => {
      const seqA = a.sequenceInRouteGroup ?? 0;
      const seqB = b.sequenceInRouteGroup ?? 0;
      return seqA - seqB;
    });
  }

  onRouteSelect(event: { route: PlanningRouteModel, scrollOffset: number, isFloating?: boolean }) {
    if (event.isFloating) {
      this.onDrilldownFloating.emit({ routeId: event.route.id });
    } else {
      this.onDrilldown.emit({ routeId: event.route.id });
    }
  }
}
